import React from 'react';
import { Dialog } from '@material-ui/core';
// import Slide from '@material-ui/core/Slide';

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

//use this dialog where the form cannot be dragged and actions are passed as children
const SarasDialogFullScreen = (props)=>{
    const {isFullScreenMode, children} = props;

    if(!isFullScreenMode){
        return (<>
            {children}
        </>);
    }

    return(
        <Dialog fullScreen open={isFullScreenMode} PaperProps={{ style: { background: 'white' } }}
            // TransitionComponent={Transition}
        >
            {children}
        </Dialog>
    )
}

export default SarasDialogFullScreen;
